/**
 * Laravel Echo — private kanallar: staff-chat, support.{tenantId}
 * Auth: POST /api/broadcasting/auth, Authorization: Bearer <token>, Accept: application/json
 *
 * .env:
 *   REACT_APP_PUSHER_APP_KEY=...
 *   REACT_APP_PUSHER_APP_CLUSTER=mt1          (Pusher Cloud)
 *   REACT_APP_WS_HOST=...                     (Reverb / o‘z server — ixtiyoriy)
 *   REACT_APP_WS_PORT=8080
 *   REACT_APP_WSS_PORT=8080
 *   REACT_APP_WS_SCHEME=https
 */
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { buildAbsoluteUrl } from '../config/apiConfig';

let echoInstance = null;

function getAccessToken() {
  try {
    if (typeof window === 'undefined') return null;
    const a = window.localStorage?.getItem?.('access_token');
    const b = window.localStorage?.getItem?.('auth_token');
    const t = (a || b || '').trim();
    return t || null;
  } catch {
    return null;
  }
}

/**
 * Echo yoqilganmi (kalit .env da bo‘lsa).
 */
export function isEchoConfigured() {
  return !!(typeof process !== 'undefined' && process.env?.REACT_APP_PUSHER_APP_KEY);
}

/**
 * Bir marta yaratiladi; logout da disconnectEcho().
 */
export function initEcho() {
  if (typeof window === 'undefined') return null;

  const key = process.env.REACT_APP_PUSHER_APP_KEY;
  if (!key) return null;

  if (echoInstance) return echoInstance;

  window.Pusher = Pusher;

  const wsHost = (process.env.REACT_APP_WS_HOST || '').trim();
  const scheme = (process.env.REACT_APP_WS_SCHEME || 'https').toLowerCase();
  const forceTLS = scheme === 'https' || scheme === 'wss';

  const options = {
    broadcaster: 'pusher',
    key,
    cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER || 'mt1',
    forceTLS,
    encrypted: forceTLS,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
    authorizer: (channel) => ({
      authorize: (socketId, callback) => {
        const token = getAccessToken();
        fetch(buildAbsoluteUrl('/api/broadcasting/auth'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify({
            socket_id: socketId,
            channel_name: channel.name,
          }),
        })
          .then((res) => {
            if (!res.ok) {
              return res.text().then((txt) => {
                throw new Error(txt || res.statusText);
              });
            }
            return res.json();
          })
          .then((data) => callback(null, data))
          .catch((err) => callback(err instanceof Error ? err : new Error(String(err)), null));
      },
    }),
  };

  if (wsHost) {
    options.wsHost = wsHost;
    options.wsPort = Number(process.env.REACT_APP_WS_PORT) || 80;
    options.wssPort = Number(process.env.REACT_APP_WSS_PORT) || 443;
  }

  echoInstance = new Echo(options);
  return echoInstance;
}

export function getEcho() {
  return echoInstance;
}

export function disconnectEcho() {
  if (echoInstance) {
    try {
      echoInstance.disconnect();
    } catch {
      /* ignore */
    }
    echoInstance = null;
  }
}
